export const configConstants = {
    GETALL_REQUEST: 'CONFIGS_GETALL_REQUEST',
    GETALL_SUCCESS: 'CONFIGS_GETALL_SUCCESS',
    GETALL_FAILURE: 'CONFIGS_GETALL_FAILURE',

    UPDATE_REQUEST: 'CONFIGS_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'CONFIGS_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'CONFIGS_UPDATE_FAILURE'
};
